import { Auth, getAuth as getClientAuth } from 'firebase/auth'
import { Tenancy } from '@lib/firebase/types'
import { getCookie } from '@lib/firebase/clientCookie'
import TenantManager from './tenantManager'
import appClient from './client.app'
import {
  firebaseClientInitConfig,
  getTenanancyCookieName,
  getTenantId,
} from './config'

export const getClientTenantAuth = (): Auth => {
  // const tenancy = getCookie(getTenanancyCookieName()) as Tenancy
  const auth = getClientAuth(appClient)
  // auth.tenantId = getTenantId(tenancy ?? 'end-users-4mvub')
  auth.tenantId =
    TenantManager.getTenantId() ?? firebaseClientInitConfig.tenantIds.endUser
  return auth
}

export default getClientTenantAuth
